export default __webpack_public_path__ + "static/media/borrowIcon.59098792.svg";